const formatBooleanToString = (value: boolean | string) => {
	switch (value) {
		case true:
		case "true":
			return "true";

		case false:
		case "false":
			return "false";

		default:
			return "";
	}
};

export default formatBooleanToString;
